module.exports = "/_next/static/images/48d8acafb4bf44ccd78316583d1fd5ba-coins-icon.svg";